export default __webpack_public_path__ + "static/media/Mask Group 26.27d6a8fe.png";